import React from 'react';
import "./index.css";
import { HeroSection } from './HeroSection';
import { HowItWork } from './HowItWork';
import { FeaturedProperty } from './FeaturedProperty';
import { WhySnapBid } from './WhySnapBid';
import { WhatOurClients } from './WhatOurClients';
import { StartYourProject } from './StartYourProject';

export const Home= () => {
  return (
    <div className='HomeContainer'>
      <HeroSection/>
      <HowItWork/>
      <FeaturedProperty/>
      <WhySnapBid/>
      <WhatOurClients/>
      <StartYourProject/>
        
    </div>
  )
}
